module.exports = {
	"base": {
		"welcome": "Chào mừng bạn tới Mulligans, %{name}!",
		"user": "Thông tin người dùng",
		"devices": "Thiết bị",
		"refunds": "Khoản hoàn trả",
		"resources": "Tài nguyên",
		"transactions": "Giao dịch & Hoàn tiền",
		"email": "Email",
		"password": "Mật khẩu",
		"save": "Lưu",
		"sign-out": "Đăng xuất",
		"cancel": "Hủy",
		"close": "Đóng",
		"learn-more": "Tìm hiểu thêm",
		"required": "Bắt buộc",
		"support": "Hỗ trợ",
		"bookshelf": "Bookshelf",
		"launch": "Khởi chạy",
		"download": "Tải xuống",
		"details": "Chi tiết",
		"cannot-be-blank": "%{field} không thể bỏ trống.",
		"saving": "Đang lưu...",
		"done": "Hoàn thành",
		"failed": "Không thành công",
		"copy": "Sao chép"
	},
	"signin": {
		"login-failure": "Email hoặc mật khẩu không chính xác",
		"welcome-large": "Chào mừng bạn tới <span class='inner'>Trung tâm tài khoản %{brand}</span>",
		"welcome-small": "<span class='inner'>Trung tâm tài khoản</span>",
		"signin-button": "Đăng nhập",
		"forgot-password": "Bạn quên mật khẩu",
		"new-to-vst": "Bạn mới biết %{brand}?",
		"create-account": "Tạo tài khoản",
		"signing-in": "Đăng nhập...",
		"signin-failed": "Đăng nhập không thành công"
	},
	"transactions": {
		"price": "Giá",
		"excluded": "(Không bao gồm thuế)",
		"quantity": "Số lượng",
		"confirmation#": "Số xác nhận",
		"payment": "Thanh toán",
		"purchased": "Đã mua",
		"purchase-details": "Chi tiết mua hàng",
		"subtotal": "Tổng con",
		"total": "Tổng",
		"tax": "Thuế",
		"loading": "Xin chào, chúng tôi đang tải giao dịch của bạn...",
		"no-purchases": "Bạn chưa có giao dịch mua nào.",
		"seller-vat": "VAT bán hàng",
		"total-vat": "Tổng %{vat} đã thanh toán",
		"portion": "Thuế %{subTax} %{rate}%",
		"vat-disclosure": "Giá bao gồm %{vat}",
		"purchases": "Mua hàng",
		"refunded-items": "Các mục đã hoàn tiền",
		"book-title": "Tiêu đề sách",
		"refund-details": "Chi tiết hoàn tiền",
		"print-receipt": "In hóa đơn",
		"request-refund": "Yêu cầu hoàn tiền",
		"expired": "Đã hết hạn",
		"expires-in": "Hết hạn %{date}",
		"details-refund": "Chi tiết & Hoàn tiền",
		"modal": {
			"cant-refund-title": "Khoản hoàn trả không khả dụng",
			"cant-refund": "Sách của bạn không thể hoàn trả vì một hoặc nhiều lý do sau đây.",
			"cant-refund-1": "Sách của bạn đã được xem quá nhiều.",
			"cant-refund-2": "Đã hơn 14 ngày kể từ ngày mua.",
			"cant-refund-3": "Mã các tài nguyên trực tuyến của bạn đã được hiển thị.",
			"cant-refund-4": "Sách của bạn đã được hoàn trả trước đó.",
			"cant-refund-5": "Tất cả các mã đã được đổi thưởng và/hoặc hoàn tiền",
			"cant-refund-6": "Đã hơn 30 ngày kể từ ngày mua.",
			"cant-refund-support": "Nếu bạn vẫn chưa hiểu rõ chính sách hoàn trả của %{brand}, hãy liên hệ với <a href='%{support_url}' target='_blank'>bộ phận hỗ trợ</a>."
		},
		"license": {
			"perpetual": "Truy cập trực tuyến không hết hạn",
			"days": "%{days} ngày truy cập"
		}
	},
	"devices": {
		"description": "%{brand} cho phép bạn kích hoạt <span>%{desktop}</span> máy tính và <span>%{mobile}</span> thiết bị di động/máy tính bảng vào bất kỳ thời điểm cụ thể nào.",
		"loading": "Xin chào, chúng tôi đang truy cập thiết bị của bạn :)",
		"no-active": "Bạn không có thiết bị hiện hoạt nào.",
		"deactivate": "Hủy kích hoạt"
	},
	"user": {
		"personal-information": "Thông tin cá nhân",
		"security-information": "Thông tin bảo mật",
		"notifications": "Thông báo",
		"first-name": "Tên",
		"last-name": "Họ",
		"change-password-title": "Thay đổi mật khẩu",
		"current-password": "Mật khẩu hiện tại",
		"new-password": "Mật khẩu mới",
		"security-password": "Mật khẩu",
		"confirm-new-password": "Xác nhận mật khẩu mới",
		"security-question": "Câu hỏi bảo mật",
		"security-info-change": "Thay đổi",
		"question": "Câu hỏi",
		"answer": "Trả lời",
		"notifications-text": "Email cho tôi cập nhật thường xuyên về hoạt động tài khoản của tôi, các cập nhật sản phẩm và lời mời đặc biệt.",
		"loading": "Spot đang phân tích thông tin người dùng của bạn, hãy chờ một lát 🐶",
		"change-password-text": "Mật khẩu phải gồm ít nhất 8 ký tự, trong đó có một chữ viết hoa, một chữ viết thường và một ký tự đặc biệt.",
		"email-locked": "Email đã bị khóa",
		"email-locked-description": "Bạn không có quyền truy cập để thay đổi email của mình.",
		"email-locked-more": "Vui lòng liên hệ với quản trị viên của bạn.",
		"security-question6": "Môn thể thao ưa thích của bạn là gì?",
		"security-question7": "Vị kem ưa thích của bạn là gì?",
		"security-question8": "Tên vật nuôi ưa thích của bạn là gì?",
		"security-question9": "Khi còn nhỏ, bạn muốn trở thành người như thế nào khi lớn lên?",
		"security-question10": "Họ của giáo viên ưa thích của bạn là gì?",
		"new-password-failure": "Mật khẩu không đáp ứng yêu cầu",
		"confirm-password-failure": "Mật khẩu phải khớp",
		"new-password-tooltip": "Phải gồm ít nhất 8 ký tự, trong đó có một chữ viết hoa, một chữ viết thường và một ký tự đặc biệt.",
		"enter-valid-email": "Vui lòng nhập email hợp lệ.",
		"password-cannot-be-same": "Mật khẩu không thể giống mật khẩu trước đây",
		"incorrect-password": "Mật khẩu không chính xác",
		"complete-account": "Có vẻ như bạn cần <a href='%{href}'>hoàn tất tài khoản của mình</a>.",
		"completing-allows": "Việc hoàn tất tài khoản cho phép bạn đọc sách ngoại tuyến trên ứng dụng di động của chúng tôi cũng như chia sẻ ghi chú và các điểm nổi bật với bạn bè.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Các phần bổ sung",
		"access-codes": "Mã truy cập",
		"print-on-demand": "In theo yêu cầu",
		"check-pod": "Chọn tùy chọn in của nhà xuất bản cho sách của bạn.",
		"check-now": "Xem ngay",
		"loading": "Hãy chờ, chúng tôi đang cập nhật tài nguyên của bạn!",
		"in": "trong",
		"access-code-intro": "Mã truy cập là mật khẩu bạn sử dụng để truy cập trực tuyến nội dung khóa học. Sau khi hiển thị mã cho một mục, bạn sẽ không thể quay lại mục này. Để biết thêm hướng dẫn về cách sử dụng mã truy cập của bạn, hãy đi tới <a href='%{support_url}' target='_blank'>Hỗ trợ</a>.",
		"expires": "Hết hạn",
		"expiration-message": "Gồm các hướng dẫn sử dụng mã truy cập của bạn.",
		"copy-fail": "Không thể sao chép. Vui lòng chọn và sao chép thủ công mã.",
		"launch-site": "Khởi chạy trang web",
		"launch-book": "Khởi chạy sách",
		"reveal-code": "Hiển thị mã",
		"no-resources": "Bạn không có tài nguyên nào.",
		"no-access-codes": "Bạn không có mã truy cập nào.",
		"no-ancillaries": "Không có phần bổ sung nào cho tiêu đề này",
		"name": "Tên",
		"type": "Loại",
		"size": "Kích cỡ",
		"download-all": "Tải xuống tất cả",
		"back": "Quay lại tài nguyên"
	},
	"refunds": {
		"states": {
			"refunded": "Đã hoàn trả",
			"unavailable": "Hoàn trả không khả dụng"
		},
		"reasons": {
			"dropped": "Tôi đã bỏ khóa học",
			"wrong": "Sách này không phù hợp với khóa học của tôi",
			"print": "Thay vào đó, tôi đã quyết định mua một phiên bản in",
			"missing": "Sách này không có mọi nội dung tôi cần cho khóa học (ví dụ: CD, truy cập web, video)",
			"other": "Khác"
		},
		"bulk": {
			"policy": "Bằng việc nhấp vào nút &quot;Hoàn tất hoàn trả&quot; bên dưới, tôi đồng ý với chính sách hoàn trả của %{brand} <a href='%{policy_url}' target='_blank'> .</a>.",
			"complete": "Hoàn tất hoàn trả",
			"view-details": "Xem chi tiết hoàn trả",
			"success": "Đã yêu cầu hoàn tiền cho bạn. Vui lòng đợi 48 giờ để xử lý.",
			"failure": "Rất tiếc - đã xảy ra sự cố! Đáng tiếc là hoạt động hoàn trả của bạn không được chấp nhận.",
			"retry": "Thử lại",
			"support": "Liên hệ với bộ phận hỗ trợ",
			"available-codes": "Mã khả dụng",
			"codes-selected": "Mã đã được chọn",
			"download": "Tải xuống mã",
			"partially-refunded": "Đã hoàn trả một phần",
			"pick-one": "Bạn phải chọn ít nhất một mã để thực hiện hoàn trả"
		},
		"refund": "Hoàn trả",
		"all": "Hoàn trả toàn bộ?",
		"missing-reason": "Bạn phải chọn một lý do để tiếp tục",
		"missing-elaboration": "Vui lòng nêu thêm chi tiết",
		"policy": "Bằng việc nhấp vào nút “Hoàn tất yêu cầu hoàn trả” bên dưới, tôi hiểu rằng nếu tôi mua sách điện tử của %{brand} lần nữa, tôi sẽ không đủ điều kiện yêu cầu bất kỳ khoản hoàn trả nào khác cho sách điện tử tương tự. Xem toàn bộ chính sách hoàn trả.",
		"refunded": "Đã hoàn trả",
		"sorry": "Chúng tôi rất tiếc khi bạn không hài lòng với sản phẩm mua.",
		"error": "Đã xảy ra sự cố",
		"error-explain": "Chúng tôi không thể xử lý khoản hoàn trả của bạn. Vui lòng thử lại.",
		"why": "Cho chúng tôi biết lý do?",
		"no-refunds": "Bạn không có mục được hoàn trả nào.",
		"select-codes": "Chọn (các) mã để hoàn trả:",
		"number": "Số lượng?",
		"back": "Quay lại khoản hoàn trả"
	},
	"purchases": {
		"back": "Quay lại giao dịch mua"
	},
	"global-bar": {
		"account": "Cài đặt tài khoản"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/vi.json
 ** module id = 1002
 ** module chunks = 0
 **/